import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import DirectUseSoldTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import "./index.css";
import directIcon from "../../../../../assets/design-revamp-company/category-icons/direct-use-icon.svg";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
const CompDirectUseSoldContent = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;
  return (
    <div className="use-sold-contents">
      <div style={{ display: "flex", alignItems: "center" }}>
        <SubHeaderBox
          subTitle={t("COMP_DIRECT_TITLE")}
          subDescription={t("DIRECT_USE_OF_SOLD_DESC")}
          isNormal={true}
          number={"16.1"}
          icon={directIcon}
        />
      </div>
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`prod-directusesold-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          {" "}
          <DirectUseSoldTable productId={productId} />
        </TableLoadingWrapper>
      )}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default CompDirectUseSoldContent;
